<template>
    <div>
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="alert alert-danger" v-if="errorMessage" v-html="errorMessage"></div>
                <div class="alert alert-info" v-if="infoMessage" v-html="infoMessage"></div>
                <b-row>
                    <b-col>
                        <label class="form-control-label demos">Product Name</label>
                        <validated-input name="Product Name"
                                         :rules="{required: true}" v-model="model.product_name"></validated-input>
                    </b-col>
                    <b-col>
                        <label class="form-control-label demos">MRP</label>
                        <validated-input name="MRP"
                                         :rules="{required: true}" v-model="model.mrp"></validated-input>
                    </b-col>
                    <b-col>
                        <label class="form-control-label demos">Selling Price</label>
                        <validated-input name="selling_price"
                                         :rules="{required: true}" v-model="model.selling_price"></validated-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label class="form-control-label demos">Display Name</label>
                        <validated-input name="Display Name"
                                         :rules="{required: false}" v-model="model.display_name"></validated-input>
                    </b-col>
                    <b-col>
                        <label class="form-control-label demos">Quantity</label>
                        <validated-input name="Quantity"
                                         :rules="{required: true}" v-model="model.quantity"></validated-input>
                    </b-col>
                    <b-col>
                        <label class="form-control-label demos">Inactive</label>
                        <validated-checkbox class="form-control" name="Disabled"
                                            :rules="{required: false}" v-model="model.disabled"></validated-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label class="form-control-label demos">Description</label>
                        <validated-input name="Description"
                                         :rules="{required: true}">
                            <textarea class="form-control" v-model="model.description"></textarea>
                        </validated-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label class="form-control-label demos" for="Icon">Product Image</label>
                        <b-form-file
                            v-model="model.product_image" id="Icon"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."></b-form-file>
                    </b-col>
                    <b-col>
                        <label class="form-control-label demos">Product Category</label>
                        <validated-vue-select name="Product Category"
                                              :options-u-r-l="CategoryOptions"
                                              :rules="{required: false}"
                                              v-model="model.product_category"></validated-vue-select>
                    </b-col>
                </b-row>
                <loading-button loading-text="Saving..." text="Update" :saving="loading"></loading-button>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import axios from 'secure-axios';
import urls from '../../../data/urls';

export default {
    name: 'EditProduct',
    props: { model: { type: Object } },
    data () {
        return {
            loading: false,
            infoMessage: '',
            errorMessage: '',
            CategoryOptions: urls.admin.category.options
        };
    },
    methods: {
        onSubmit () {
            const formValidator = this.$refs.formValidator;
            this.loading = true;
            const component = this;
            axios.form(urls.admin.product.addEdit, component.model).then(function (data) {
                const json = data.data;
                if (json.error === false) {
                    component.$notify('Successfully Updated Product..!', 'success',
                        {
                            type: 'success',
                            duration: 3000,
                            permanent: false
                        });
                    component.$emit('success');
                } else {
                    // console.log(json);
                    formValidator.setErrors(json.errors);
                    component.errorMessage = json.errors.all || '';
                    component.$notify(json.errors, 'Error',
                        {
                            type: 'warning',
                            duration: 3000,
                            permanent: false
                        }
                    );
                }
                component.loading = false;
            }).catch(function () {
                component.loading = false;
                component.$notify('Something went wrong..!', 'Error',
                    {
                        type: 'warning',
                        duration: 3000,
                        permanent: false
                    }
                );
            });
        }
    }
};
</script>

<style>
.demos {
    margin-bottom: 5px;
}
</style>
